import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDistribucionPorCondicionActions'
import { TablaDistribucionPorCondicionView } from '../components/TablaDistribucionPorCondicionView'

class TablaDistribucionPorCondicion extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable(this.props.conLink)
  }

  render () {
    return <TablaDistribucionPorCondicionView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDistribucionPorCondicion)
